export default "__VITE_ASSET__BEZ45riF__"